var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    className: "lodar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: "100px",
    width: "100px",
    fill: "white",
    stroke: "none",
    className: "bg"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    height: "10px",
    width: "0px",
    fill: "red",
    stroke: "none",
    className: "bar"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    height: "10px",
    width: "40px",
    fill: "none",
    stroke: "black",
    className: "frame"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.ea25247e7bd546cd8860e82740bbc1aa.svg";
export { ForwardRef as ReactComponent };